module.exports = __webpack_public_path__ + "static/media/Edit-Check-On.788abae7.svg";